export const QUARTERS = [
  {
    id: 1, label: 'Q1', startMonth: 'Jul', endMonth: 'Sep',
  },
  {
    id: 2, label: 'Q2', startMonth: 'Oct', endMonth: 'Dec',
  },
  {
    id: 3, label: 'Q3', startMonth: 'Jan', endMonth: 'Mar',
  },
  {
    id: 4, label: 'Q4', startMonth: 'Apr', endMonth: 'Jun',
  },
];

export const TTM_SITE_STATUSES = [
  { id: 1, label: 'Inactive' },
  { id: 2, label: 'Active' },
  { id: 3, label: 'Unattended' },
  { id: 4, label: 'Not Necessary or Redundant' },
];

export const TRAFFIC_LIGHT_COLOURS = {
  GREEN: '#5FAB12',
  YELLOW: '#F7C622',
  ORANGE: '#F66F22',
  RED: '#C01F24',
  GREY: '#b9bfc6',
};

export const SPLIT_CIRCLE_COLOURS = {
  BLUE: '#23aefe',
  LIGHT_BLUE: '#7ed2ff',
  DARK_BLUE: '#0083CB',
};

export const DATA_QUALITY_COLOURS = {
  DQCOLOR1: '#2e22ac',
  DQCOLOR2: '#5e2ea8',
  DQCOLOR3: '#9b3ca4',
  DQCOLOR4: '#df4a9c',
};

// These are the colours used by bar, tornado and line charts
export const CHART_COLOURS = {
  red: 'rgb(232, 31, 1)',
  blue: 'rgb(36, 137, 239)', // dodger blue
  lightblue: 'rgb(58, 193, 251)',
  black: 'rgb(30, 30, 30)', // gray 30
  white: 'rgb(255, 255, 255)',
  grey: 'rgba(127, 127, 127, 1.0)',
  transred: 'rgba(250, 128, 114)', // salmon 0.6
  transblue: 'rgba(70, 130, 180)', // steelblue3 0.6
  transgrey: 'rgba(127, 127, 127)', // grey50 0.6 - used by the stacked area graphs so that the x-axis grid shines through
  transgreen: 'rgba(102, 221, 170)', // mediumaquamarine 0.6 #66ddaa
  transorange: 'rgba(237,137,54)',
  transpurple: 'rgba(147, 112, 219)',
  lightgrey: 'rgba(80, 80, 80, 0.3)',
  darkgrey: 'rgba(47, 47, 47, 0.3)',
  darkblue: 'rgb(0, 84, 133)',
  orange: 'rgb(237,137,54)',
  // used by economic chart
  orangered: 'rgb(255,69,0)',
  seagreen: 'rgb(67,205,128)',
  magenta: 'rgb(139, 0, 127)',
  purple: 'rgb(147, 0, 170)',
  yellow: 'rgb(246, 214, 4)',
};

// these are the lovely colours used by the SSRS report =^x.x^=
export const SSRSColours = {
  orange: '#e38628', // drab orange
  blue: '#7a9ca1', // drab blue-ish
};

// Note: It is important this order remains as it is used to map the indicator text base on values

export const overallActivityAssessmentsLegend = [
  { label: 'Not assessed', color: TRAFFIC_LIGHT_COLOURS.GREY },
  { label: 'Good/Effective (>80)', color: TRAFFIC_LIGHT_COLOURS.GREEN },
  { label: 'Fit for purpose/developing (>60 to 80)', color: TRAFFIC_LIGHT_COLOURS.YELLOW },
  { label: 'Room for improvement (>40 to 60)', color: TRAFFIC_LIGHT_COLOURS.ORANGE },
  { label: 'Unacceptable/basic (<=40)', color: TRAFFIC_LIGHT_COLOURS.RED },
];

export const activityAssessmentsLegend = [
  { label: 'Not assessed', color: TRAFFIC_LIGHT_COLOURS.GREY },
  { label: 'Good (>2.25)', color: TRAFFIC_LIGHT_COLOURS.GREEN },
  { label: 'Fit for purpose (>1.5 to 2.25)', color: TRAFFIC_LIGHT_COLOURS.YELLOW },
  { label: 'Room for improvement (<=1.5)', color: TRAFFIC_LIGHT_COLOURS.ORANGE },
];

export const smartBuyerAssessmentsLegend = [
  { label: 'Not assessed', color: TRAFFIC_LIGHT_COLOURS.GREY },
  { label: 'A smart buyer', color: TRAFFIC_LIGHT_COLOURS.GREEN },
  { label: 'Developing', color: TRAFFIC_LIGHT_COLOURS.YELLOW },
  { label: 'Limited', color: TRAFFIC_LIGHT_COLOURS.ORANGE },
  { label: 'Basic', color: TRAFFIC_LIGHT_COLOURS.RED },
];

export const amenityAndConditionLegend = [
  { label: 'Increasing trend of 1% or greater', color: TRAFFIC_LIGHT_COLOURS.GREEN },
  { label: 'Between a 1% decrease and 1% increase', color: TRAFFIC_LIGHT_COLOURS.YELLOW },
  { label: 'Decreasing trend of 1% or greater', color: TRAFFIC_LIGHT_COLOURS.RED },
];

export const safetyLegend = [
  { label: 'Decreasing trend of 1% or greater', color: TRAFFIC_LIGHT_COLOURS.GREEN },
  { label: 'Between a 1% decrease and 1% increase', color: TRAFFIC_LIGHT_COLOURS.YELLOW },
  { label: 'Increasing trend of 1% or greater', color: TRAFFIC_LIGHT_COLOURS.RED },
];

export const deliveryPerformanceLegend = [
  { label: 'Less than 10% variance', color: TRAFFIC_LIGHT_COLOURS.GREEN },
  { label: 'Between a 10% and 20% variance', color: TRAFFIC_LIGHT_COLOURS.YELLOW },
  { label: 'Greater than 20% variance', color: TRAFFIC_LIGHT_COLOURS.RED },
];

export const publicTransportLegend = [
  { label: 'Increasing trend of 1% or greater', color: TRAFFIC_LIGHT_COLOURS.GREEN },
  { label: 'Between a 1% decrease and 1% increase', color: TRAFFIC_LIGHT_COLOURS.YELLOW },
  { label: 'Decreasing trend of 1% or greater', color: TRAFFIC_LIGHT_COLOURS.RED },
];

export const servicePerformanceLegend = [
  { label: 'Not Reported', color: TRAFFIC_LIGHT_COLOURS.GREY },
  { label: 'Target achieved', color: TRAFFIC_LIGHT_COLOURS.GREEN },
  { label: 'Target partially achieved', color: TRAFFIC_LIGHT_COLOURS.ORANGE },
  { label: 'Target not achieved', color: TRAFFIC_LIGHT_COLOURS.RED },
];

export const servicePerformanceKpiLegend = [
  { label: '80% or more', color: TRAFFIC_LIGHT_COLOURS.GREEN },
  { label: '60% to 80%', color: TRAFFIC_LIGHT_COLOURS.YELLOW },
  { label: 'Less than 60%', color: TRAFFIC_LIGHT_COLOURS.RED },
];

export const e3Legend = [
  { label: 'Higher', color: SPLIT_CIRCLE_COLOURS.DARK_BLUE },
  { label: 'Medium', color: SPLIT_CIRCLE_COLOURS.BLUE },
  { label: 'Lower', color: SPLIT_CIRCLE_COLOURS.LIGHT_BLUE },
];

export const stateHighwaysPotholeRepairsLegend = [
  { label: 'Greater than or equal to 90%', color: TRAFFIC_LIGHT_COLOURS.GREEN },
  { label: 'Less than 90%', color: TRAFFIC_LIGHT_COLOURS.RED },
];

export const temporaryTrafficManagementLegend = [
  { label: 'Less than 10% variance', color: TRAFFIC_LIGHT_COLOURS.GREEN },
  { label: 'Between 10% and 20% variance', color: TRAFFIC_LIGHT_COLOURS.YELLOW },
  { label: 'Greater than 20% variance', color: TRAFFIC_LIGHT_COLOURS.RED },
];

export const coassuranceAssessmentLegend = [
  { label: 'Not Available/Not Applicable', color: TRAFFIC_LIGHT_COLOURS.GREY },
  { label: 'Unsatisfactory', color: TRAFFIC_LIGHT_COLOURS.RED },
  { label: 'Significant improvement needed', color: TRAFFIC_LIGHT_COLOURS.ORANGE },
  { label: 'Some improvement needed', color: TRAFFIC_LIGHT_COLOURS.YELLOW },
  { label: 'Effective', color: TRAFFIC_LIGHT_COLOURS.GREEN },
];

export const coinvestorAssuranceFourGradeLegend = [
  { label: 'Not Available/Not Applicable', color: TRAFFIC_LIGHT_COLOURS.GREY },
  { label: 'Effective', color: TRAFFIC_LIGHT_COLOURS.GREEN },
  { label: 'Some improvement needed', color: TRAFFIC_LIGHT_COLOURS.YELLOW },
  { label: 'Significant improvement needed', color: TRAFFIC_LIGHT_COLOURS.ORANGE },
  { label: 'Unsatisfactory', color: TRAFFIC_LIGHT_COLOURS.RED },
];

export const dataQualityScoreLegend = [
  { label: '80 or more', color: DATA_QUALITY_COLOURS.DQCOLOR4 },
  { label: '70 to 79', color: DATA_QUALITY_COLOURS.DQCOLOR3 },
  { label: '50 to 69', color: DATA_QUALITY_COLOURS.DQCOLOR2 },
  { label: 'Less than 50', color: DATA_QUALITY_COLOURS.DQCOLOR1 },
];

export const roadTypeOptions = [
  { value: 'shlr', label: 'All Roads' },
  { value: 'sh', label: 'State Highways' },
  { value: 'lr', label: 'Local Roads' },
];
